let cursorX = window.innerWidth / 2;
let cursorY = window.innerHeight / 2;

export function bindCursor() {
  const cursor = document.querySelector(".ai-cursor") as HTMLElement;
  if (!cursor) return;

  // Track mouse position
  window.addEventListener("mousemove", (e) => {
    cursorX += (e.clientX - cursorX) * 0.18;
    cursorY += (e.clientY - cursorY) * 0.18;

    cursor.style.transform = `translate(${cursorX}px, ${cursorY}px)`;
  });

  // Add scanning state on hover over interactive elements
  const interactiveSelectors = [
    ".btn",
    ".panel",
    ".stat-card",
    ".timeline-item",
    ".terminal-link",
    "a",
  ];

  interactiveSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.addEventListener("mouseenter", () => {
        cursor.classList.add("scanning");
      });
      el.addEventListener("mouseleave", () => {
        cursor.classList.remove("scanning");
      });
    });
  });
}
